import { render } from "./Post.vue?vue&type=template&id=7c24ebad&scoped=true"
import script from "./Post.vue?vue&type=script&lang=js"
export * from "./Post.vue?vue&type=script&lang=js"

import "./Post.vue?vue&type=style&index=0&id=7c24ebad&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7c24ebad"

export default script